export default __webpack_public_path__ + "static/media/Pink-Cake.5ffe0fe3.jpg";